// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"a4-z","displaySixCardTiles":"b4-z"};